import { updateCustomerSignInStatus } from 'Store/MyAccount/MyAccount.action';
import { deleteCartId } from 'Util/Cart';
import getStore, { getStoreState } from 'Util/Store';

/** @namespace Util/Auth/LogoutIfSignedIn/logoutIfSignedIn */
export function logoutIfSignedIn() {
    const store = getStore();

    const {
        MyAccountReducer: {
            isSignedIn: isCustomerSignedIn = false,
        } = {},
    } = getStoreState();

    const { dispatch } = store;

    if (isCustomerSignedIn) {
        // since logout is async and slow, remove cart id / compare uid
        // and set customer sign in status here on auth token expiration
        deleteCartId();
        dispatch(updateCustomerSignInStatus(false));

        const MyAccountDispatcher = import('../../store/MyAccount/MyAccount.dispatcher');

        MyAccountDispatcher.then(
            ({ default: dispatcher }) => dispatcher.logout(true, true, dispatch, false),
        );
    }
}
